import { BrandSpacesDetailsActions } from './types';
import { ActionType } from 'src/store';

const initialState = {
  brandSpace: {},
};

// Main reducer function which checks the store action that has been triggered
const reducer = (state = initialState, action: ActionType) => {
  // Store actions
  const { FetchDetailsSuccess, FetchDetailsError, FetchDetailsBegin } = BrandSpacesDetailsActions;

  switch (action.type) {
    case FetchDetailsBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        designers: [],
        error: null,
      };
    }
    case FetchDetailsError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case FetchDetailsSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        brandSpace: action.payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
